import { render, staticRenderFns } from "./details-credits.vue?vue&type=template&id=034d92ca&scoped=true"
import script from "./details-credits.vue?vue&type=script&lang=js"
export * from "./details-credits.vue?vue&type=script&lang=js"
import style0 from "./details-credits.vue?vue&type=style&index=0&id=034d92ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034d92ca",
  null
  
)

export default component.exports